/********************************************************************************
 * Copyright (c) 2020 Cedalo GmbH
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 *
 ********************************************************************************/
module.exports = {
	types: {
		QoS: [{
			value: 0,
			description: 'At most once',
		}, {
			value: 1,
			description: 'At least once.',
		}, {
			value: 2,
			description: 'Exactly once.',
		}],
		FileMode: [{
			value: 'append',
			description: 'Append to exiting file.',
		}, {
			value: 'create',
			description: 'Create new  file.',
		}]
	},
	functions: {
		'FILE.WRITE': {
			default: {
				category: 'Streams',
				description: 'Write a given range as comma separated values to a file. You can use the Function Wizard for this function. The mounted root path is set in the .YML file. E.g.: `C:rootfolder:/filefeeder`. Add /filefeeder to the "Root Directory" field in the Connector to connect it to the root folder.',
				inlineDescription: 'Write a given range as comma separated values to a file.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'File Producer to use for writing the file.',
						optional: false
					},
					{
						type: 'Range',
						name: 'Range',
						description: 'The range to write to a file. Can also be a single value.',
						optional: false
					},
					{
						type: 'String',
						name: 'Filename',
						description: 'Name of the file that is written.',
						optional: false
					},
					{
						type: 'String',
						name: 'Directory',
						description: 'The directory of the file that is written. Defaults to the root directory of the File Producer.',
						optional: true
					},
					{
						type: 'FileMode',
						name: 'Mode',
						description: 'Has to be "create" or "append". "create" replaces an existing file with the same name, "append" appends instead.',
						default: 'append',
						optional: true
					},
					{
						type: 'String',
						name: 'Separator',
						description: 'Separator to use when writing range to file.',
						default: ',',
						optional: true
					}
				],
				return: {
					type: '',
					description: 'TRUE, if no [error](../../other#error-codes).'
				},
				examples: {
					infoStart: '\n| | A | B | C |\n' +
						'|---|---|---|---|\n' +
						'|1|Example1|Example2|Example3|\n' +
						'|2|Example4|Example5|Example6|\n',
					infoEnd: '',
					formulas: [
						{
							formula: '=FILE.WRITE(&#124;FileProducer, "Message", "file.csv", "directory")',
							result: 'TRUE',
							comment: 'Write the text “Message” to the file located at “{rootDirectory}/directory/file.csv” using the “File Producer”'
						},
						{
							formula: '=FILE.WRITE(&#124;FileProducer, A1:C2,"file.csv", , "create",";")',
							result: 'TRUE',
							comment: 'Writes the content of the range A2:C3 to the field located at “{rootDirectory}/file.csv” using “;” as separator and replacing an already existing file with the same name. The resulting content of the file is:  <br />`Example1;Example2;Example3` <br /> `Example4;Example5;Example6 `'
						}
					]
				}
			}
		},
		// 'HTTP.REQUEST': {
		// 	status: 'deprecated',
		// 	alternative: 'HTTP.REQUEST2',
		// 	default: {
		// 		category: 'Streams',
		// 		description: 'Create an HTTP request. The result, of the request, if any, will be added to the inbox of the given target sheet. You can use the Function Wizard for this function.',
		// 		inlineDescription: 'Create an HTTP request.',
		// 		arguments: [
		// 			{
		// 				type: 'Producer',
		// 				name: 'Producer',
		// 				description: 'Producer to use for submitting the HTTP.request.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Path',
		// 				description: 'Path extending the base URL of the connector.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Method',
		// 				description: 'HTTP method of the request.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'Target',
		// 				name: 'Target',
		// 				description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'ResultKeys',
		// 				description: 'Limit the result to the specified JSON Keys',
		// 				optional: true
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Body',
		// 				description: 'Data to use as the body of the HTTP request.',
		// 				optional: true
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Headers',
		// 				description: 'Headers of the HTTP request.',
		// 				optional: true
		// 			},
		// 			{
		// 				type: 'Number',
		// 				name: 'Timeout',
		// 				description: 'Number of seconds after the request times out and an error is returned.',
		// 				optional: true
		// 			}
		// 		],
		// 		return: {
		// 			type: 'Number',
		// 			description: 'The function HTTP.REQUEST() always returns a unique random request ID, which is automatically generated when the service is called. Otherwise an [error](../../other#error-codes) is displayed.'
		// 		},
		// 		examples: {
		// 			infoStart: '',
		// 			infoEnd: '',
		// 			formulas: [
		// 				{
		// 					formula: '=HTTP.REQUEST(&#124;Rest,"/path","GET",INBOX())',
		// 					result: 'generated Request id',
		// 					comment: 'This makes a GET request to "{ConnectorBaseURL}/path" and writes the response to the Inbox.'
		// 				},
		// 				{
		// 					formula: '=HTTP.REQUEST(&#124;Rest,"/path","POST",INBOX("S2"),,"hello",A2:B3) <br /> <img src={require("../../_images/REST.REQUEST.png").default} width="100%"/>',
		// 					result: 'generated Request id',
		// 					comment: 'This makes a POST request to “{ConnectorBaseURL}/path” with “hello” as body and “Content-Type: text/plain” and “Custom-Header: example” as headers. The response is placed in the Inbox of S2'
		// 				}
		// 			]
		// 		}
		// 	}
		// },
		// 'HTTP.RESPOND': {
		// 	license: 'enterprise',
		// 	default: {
		// 		category: 'Streams',
		// 		description: 'Sends either arbitrary JSON data or a message from the outbox to specified Producer. Usually this function is used to respond to a previously received *request*-message. You can use the Function Wizard for this function.',
		// 		inlineDescription: 'Sends either arbitrary JSON data or a message from the outbox to specified Producer',
		// 		arguments: [
		// 			{
		// 				type: 'Consumer',
		// 				name: 'Consumer',
		// 				description: 'Name of the Consumer to use for sending respond.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'Number',
		// 				name: 'RequestId',
		// 				description: 'The *requestId* as provided by a previously received *request*-message',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Body',
		// 				description: 'Data to send as response.',
		// 				optional: false
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'StatusCode',
		// 				description: 'Defaults to 200. HTTP status code of the response.',
		// 				default: '200',
		// 				optional: true
		// 			},
		// 			{
		// 				type: 'String',
		// 				name: 'Headers',
		// 				description: 'Headers of the response.',
		// 				optional: true
		// 			}
		// 		],
		// 		return: {
		// 			type: 'Boolean',
		// 			description: 'TRUE on success or [error](../../other#error-codes) code otherwise.'
		// 		},
		// 		examples: {
		// 			infoStart: 'We assume that a *request*-message was received and that it provides a *requestId* which we store to cell B1 by using the read function as follows: `READ(INBOXMETADATA(,,"requestId"), B1, "String")` ',
		// 			infoEnd: '',
		// 			formulas: [
		// 				{
		// 					formula: '=HTTP.RESPOND(&#124;Rest,B1,DICTIONARY(A3:C5))',
		// 					result: 'TRUE',
		// 					comment: 'Sends the JSON data provided by the DICTIONARY function to the Consumer named Rest using the requestId in B1'
		// 				},
		// 				{
		// 					formula: '=HTTP.RESPOND(&#124;Rest,B1,"Not Found",404,A2:B2) <br /> <img src={require("../../_images/REST.RESPOND.png").default} width="100%"/>',
		// 					result: 'TRUE',
		// 					comment: 'Responds to the request corresponding to requestId with the body “Not Found”, status code “404” and the header “Content-Type: text/plain”.'
		// 				}
		// 			]
		// 		}
		// 	}
		// },
		'KAFKA.COMMAND': {
			default: {
				category: 'Streams',
				description: 'Allows KSQL commands to be used. You can use the Function Wizard for this function.',
				inlineDescription: 'Allows KSQL commands to be used. You can use the Function Wizard for this function.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use.',
						optional: false
					},
					{
						type: 'String',
						name: 'Command',
						description: 'Any command allowed in KSQL table.',
						optional: false
					},
					{
						type: 'Target',
						name: 'Target',
						description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
						optional: false
					},
					{
						type: 'Number',
						name: 'Timeout',
						description: 'A period in seconds to wait for an answer.',
						default: 20,
						optional: true
					}
				],
				return: {
					type: 'Boolean',
					description: 'TRUE, if no [error](../../other#error-codes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.COMMAND(&#124;KafkaProducer, "CREATE TABLE ksqltable201 (random BIGINT, type VARCHAR) WITH (kafka_topic=\'cedalo\', value_format=\'JSON\', key = \'random\')", INBOX ())',
							result: 'TRUE',
							comment: 'A KSQL table will be created with the name ksqltable201.'
						}
					]
				}
			}
		},
		'KAFKA.PUBLISH': {
			default: {
				category: 'Streams',
				description: 'Publishes either a message or an arbitrary value using a specified Producer and topic. To reference a message from the outbox use the outbox function and to reference a message from the inbox use INBOX. You can use the Function Wizard for this function.',
				inlineDescription: 'Publishes either a message or an arbitrary value using a specified Producer and topic.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use for publishing.',
						optional: false
					},
					{
						type: 'String',
						name: 'Message',
						description: 'Either an existing message from the outbox a JSON or a primitive value to publish.',
						optional: false
					},
					{
						type: 'String',
						name: 'Topic',
						description: 'Topic the message is published to.',
						optional: false
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error](../../other#error-codes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.PUBLISH(&#124;Kafka Producer,"Message","test")',
							result: 'TRUE',
							comment: 'This publishes the string value "Message" using the "Kafka Producer" to the topic "test"'
						}
					]
				}
			}
		},
		'KAFKA.QUERY': {
			default: {
				category: 'Streams',
				description: 'Allows KSQL queries to be used. You can use the Function Wizard for this function.',
				inlineDescription: 'Allows KSQL queries to be used. You can use the Function Wizard for this function.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use.',
						optional: false
					},
					{
						type: 'String',
						name: 'Query',
						description: 'Any query allowed on a KSQL table.',
						optional: false
					},
					{
						type: 'Target',
						name: 'Target',
						description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
						optional: false
					},
					{
						type: 'Number',
						name: 'Timeout',
						description: 'A period in seconds to wait for an answer.',
						default: 20,
						optional: true
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error](../../other#error-codes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=KAFKA.Query(&#124;Kafka Producer, "select * from ksqltable200", INBOX())',
							result: 'TRUE',
							comment: 'The complete data from ksqltable200 will be shown in the inbox.'
						}
					]
				}
			}
		},
		'MAIL.SEND': {
			default: {
				category: 'Streams',
				description: 'Send a mail using the given producer and parameters. You can use the Function Wizard for this function.',
				inlineDescription: 'Send a mail using the given producer and parameters.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Mail Producer to use for sending mail.',
						optional: false
					},
					{
						type: 'String',
						name: 'Message',
						description: 'Simple text used as content of the mail',
						optional: false
					},
					{
						type: 'String',
						name: 'Subject',
						description: 'Simple text',
						optional: false
					},
					{
						type: 'String',
						name: 'TO',
						description: 'Single mail address or range of mail addresses.',
						optional: true
					},
					{
						type: 'String',
						name: 'CC',
						description: 'Single mail address or range of mail addresses.',
						optional: true
					},
					{
						type: 'String',
						name: 'BCC',
						description: 'Single mail address or range of mail addresses.',
						optional: true
					},
					{
						type: 'Range',
						name: 'Attachments',
						description: 'Range of Attachments, see example below.',
						optional: true
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error](../../other#error-codes).'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=MAIL.SEND(&#124;Mail Produer,“Message”,“Subject”,“user@example.org”)',
							result: 'TRUE',
							comment: 'Send a mail with the content “Message” and the subject “Subject” to “user@example.org” using the “Mail Producer”'
						},
						{
							formula: '=MAIL.SEND(&#124;Mail Producer,“Message”,“Subject”,A1:B2, “user2@example.org”,“user3@example.org”)',
							result: 'TRUE',
							comment: 'Send a mail with the content “Message” and the subject “Subject” to all mail addresses in the A1:B2 range and with “user2@example.org” in CC and “user3@example.org” in BCC using the “Mail Producer”.'
						},
						{
							formula: '=MAIL.SEND(&#124;Mail Prodcuer,"Message","Subject","user@example.org",,,A3:D4)  <br /> <img src={require("../../_images/MAIL.SEND.png").default} width="100%"/>',
							result: 'TRUE',
							comment: 'Send a mail with two attachments. <br />The first attachment is text file name “file.txt” with “A text” as content. The second attachment is an image named “image.jpeg” with the base64 value of the image as content. <br />The encoding defaults to “utf-8” and could be omitted for “file.txt”. The “Content-Type” column is optional and not required in most cases since the Content-Type will be determined from the file extension.'
						}
					]
				}
			}
		},
		PRODUCE: {
			default: {
				category: 'Streams',
				description: 'Produces a message using the specified Producer and a JSON configuration. Use JSON to create a configuration object or reference an existing configuration from the outbox using the outbox function or from the inbox using INBOX.',
				inlineDescription: 'Produces a message using the specified Producer and a JSON configuration.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use for producing.',
						optional: false
					},
					{
						type: 'JSON',
						name: 'JSONConfiguration',
						description: 'A JSON that is either an existing message from the outbox or inbox, or created with JSON or DICTIONARY. A "message" field is required, all other fields depend on the used Producer.',
						optional: false
					}
				],
				return: {
					type: 'Boolean or Error',
					description: 'TRUE, if no [error](../../other#error-codes).'
				}
			}
		},
		REQUEST: {
			default: {
				category: 'Streams',
				description: 'Create an https request. The request parameters are defined by creating a message. The parameter definition can be derived from: <https://github.com/request/request#requestoptions-callback> . The result, of the request, if any, will be added to the inbox of the given target sheet.',
				inlineDescription: 'Create an https request. The request parameters are defined by creating a message.',
				arguments: [
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Producer to use for submitting the request.',
						optional: false
					},
					{
						type: 'JSON',
						name: 'ParameterJSON',
						description: 'Message with JSON Structure defining the request parameters.',
						optional: false
					},
					{
						type: 'Target',
						name: 'Target',
						description: 'INBOX(), OUTBOX("MsgID") or a cell range where the result will be placed. Make sure the cell range is big enough or not everything is displayed.',
						optional: false
					},
					{
						type: 'String',
						name: 'ResultKeys',
						description: 'Limit the result to the specified JSON Keys',
						optional: true
					},
					{
						type: 'Number',
						name: 'Timeout',
						description: 'Number of seconds after the request times out and an error is returned.',
						optional: true
					}
				],
				return: {
					type: 'Number or Error',
					description: 'The function REQUEST() always returns a unique random request ID, which is automatically generated when the service is called. Otherwise an [error](../../other#error-codes) is returned.'
				},
				examples: {
					infoStart: '',
					infoEnd: '',
					formulas: [
						{
							formula: '=REQUEST(&#124;Rest,OUTBOX("Message"),INBOX("S2"))',
							result: 'generated Request id',
							comment: 'The message must exist before calling REQUEST. It is created like a normal message, which you would like to publish, using the WRITE formula.'
						}
					]
				}
			}
		},
		RESPOND: {
			license: 'enterprise',
			default: {
				category: 'Streams',
				description: 'Sends either arbitrary JSON data or a message to specified producer. Usually this function is used to respond to a previously received *request*-message. A *request*-message must provide a requestId property within its *Metadata* object.',
				inlineDescription: 'Sends either arbitrary JSON data or a message to specified producer.',
				arguments: [
					{
						type: 'String',
						name: 'MessageOrJSON',
						description: 'Data to send as response.',
						optional: false
					},
					{
						type: 'Producer',
						name: 'Producer',
						description: 'Name of the Producer to use for sending respond.',
						optional: false
					},
					{
						type: 'Number',
						name: 'requestId',
						description: 'The *requestId* as provided by a previously received *request*-message',
						optional: false
					}
				],
				return: {
					type: 'TRUE or Error',
					description: 'TRUE on success or [error](../../other#error-codes) code otherwise.'
				},
				examples: {
					infoStart: 'We assume that a *request*-message was received and that it provides a *requestId* which we store to cell B1 by using the READ function as follows: `READ(INBOXMETADATA(,,"requestId"), B1, "String")` ',
					infoEnd: '',
					formulas: [
						{
							formula: '=RESPOND(OUTBOX("Message"), "Rest", B1)',
							result: 'TRUE',
							comment: 'Sends the message with id *Message* from the outbox to the producer named *Rest* using the *requestId* in B1'
						},
						{
							formula: '=RESPOND(DICTIONARY(A3:C5), "Rest", B1)',
							result: 'TRUE',
							comment: 'Sends the JSON data provided by the dictionary function to the producer named *Rest* using the *requestId* in B1'
						}
					]
				}
			}
		},
	}};
